import React from 'react';
import cn from 'classnames';
import styles from './Button.module.css';

const ButtonComponent = ({ onClick, style, children, size, ...props }) => {
  let buttonClassName = 'btn';

  switch (style) {
    case 'ButtonSoftPrimary':
      buttonClassName += ` ${styles.ButtonSoftPrimary}`;
      break;

    case 'ButtonSoftPrimaryFullWidth':
      buttonClassName += ` ${styles.ButtonSoftPrimaryFullWidth}`;
      break;

    case 'ButtonSoftPrimaryGreen':
      buttonClassName += ` ${styles.ButtonSoftPrimaryGreen}`;
      break;
    case 'ButtonSoftPrimaryGreenFullWidth':
      buttonClassName += ` ${styles.ButtonSoftPrimaryGreenFullWidth}`;
      break;

    case 'ButtonSoftPrimarySearch':
      buttonClassName += ` ${styles.ButtonSoftPrimarySearch}`;
      break;

    case 'ButtonSoftEdit':
      buttonClassName += ` ${styles.ButtonSoftEdit}`;
      break;

    case 'ButtonSoftAdd':
      buttonClassName += ` ${styles.ButtonSoftAdd}`;
      break;

    case 'ButtonSoftEditFullWidth':
      buttonClassName += ` ${styles.ButtonSoftEditFullWidth}`;
      break;

    case 'ButtonSoftEditFullWidthWhite':
      buttonClassName += ` ${styles.ButtonSoftEditFullWidthWhite}`;
      break;

    case 'ButtonSoftDelete':
      buttonClassName += ` ${styles.ButtonSoftDelete}`;
      break;

    case 'ButtonDelete':
      buttonClassName += ` ${styles.ButtonDelete}`;
      break;

    case 'ButtonSoftDeleteFullWidth':
      buttonClassName += ` ${styles.ButtonSoftDeleteFullWidth}`;
      break;
    case 'ButtonSoftLight':
      buttonClassName += ` ${styles.ButtonSoftLight}`;
      break;
    case 'ButtonSoftLightFullWidth':
      buttonClassName += ` ${styles.ButtonSoftLightFullWidth}`;
      break;
    case 'ButtonSoftShortSort':
      buttonClassName += ` ${styles.ButtonSoftShortSort}`;
      break;
    case 'ButtonSelectedStyleDouble':
      buttonClassName += ` ${styles.ButtonSelectedStyleDouble}`;
      break;

    case 'ButtonSoftShortSortDouble':
      buttonClassName += ` ${styles.ButtonSoftShortSortDouble}`;
      break;
    case 'ButtonSelectedStyle':
      buttonClassName += ` ${styles.ButtonSelectedStyle}`;
      break;
    case 'ButtonSoftPrimaryShort':
      buttonClassName += ` ${styles.ButtonSoftPrimaryShort}`;
      break;

    default:
      buttonClassName += ` ${styles.ButtonSoftLight}`;
      break;
  }

  return (
    <button type="button" onClick={onClick} className={cn(buttonClassName, size)} {...props}>
      {children}
    </button>
  );
};

export default ButtonComponent;
